import cx from 'clsx';
import { FC } from 'react';

import styles from './styles.module.css';

type Props = {
  opened?: boolean;
  toggle: () => void;
};

const Line: FC<Pick<Props, 'opened'>> = ({ opened }) => (
  <span
    className={cx({
      [styles.line]: true,
      [styles.lineShort]: opened,
    })}
  />
);

export const Burger: FC<Props> = ({ opened, toggle }) => {
  return (
    <button
      aria-label="toggle navigation"
      className={styles.burger}
      onClick={toggle}
    >
      <Line />
      <Line opened={!opened} />
      <Line />
    </button>
  );
};
